import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

const plainText = value => String(value || "")
  .replace(/<[^>]*>/g, " ")
  .replace(/&nbsp;|&#160;/g, " ")
  .replace(/&amp;/g, "&")
  .replace(/&quot;/g, '"')
  .replace(/&#0*39;|&apos;/g, "'")
  .replace(/&#(\d+);/g, (_, code) => String.fromCodePoint(Number(code)))
  .replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCodePoint(parseInt(code, 16)))
  .replace(/\s+/g, " ").trim()

function SEO({ description, lang, meta, title, pathname, image }) {
  const { site } = useStaticQuery(graphql`
    query SiteSEO {
      site { siteMetadata { title description author siteUrl } }
    }
  `)
  const settings = site.siteMetadata
  const pageTitle = plainText(title)
  const fullTitle = pageTitle ? pageTitle + " | " + settings.title : settings.title
  const metaDescription = plainText(description || settings.description).slice(0, 160)
  const canonical = pathname ? new URL(pathname, settings.siteUrl).href : null
  const imageUrl = image ? new URL(image, settings.siteUrl).href : null
  const tags = [
    { name: "description", content: metaDescription },
    { name: "author", content: settings.author },
    { property: "og:title", content: fullTitle },
    { property: "og:site_name", content: settings.title },
    { property: "og:description", content: metaDescription },
    { property: "og:type", content: "website" },
    { property: "og:locale", content: "pl_PL" },
    { name: "twitter:card", content: imageUrl ? "summary_large_image" : "summary" },
    { name: "twitter:title", content: fullTitle },
    { name: "twitter:description", content: metaDescription },
  ]
  if (canonical) tags.push({ property: "og:url", content: canonical })
  if (imageUrl) tags.push(
    { property: "og:image", content: imageUrl },
    { property: "og:image:alt", content: pageTitle || settings.title },
    { name: "twitter:image", content: imageUrl }
  )
  return (
    <Helmet htmlAttributes={{ lang }} title={fullTitle} meta={tags.concat(meta)}>
      {canonical && <link rel="canonical" href={canonical} />}
      <link rel="stylesheet" id="prefix-style2-css" href="/css/colorbox.css?ver=3.9.2" type="text/css" media="all" />
    </Helmet>
  )
}

SEO.defaultProps = { lang: "pl", meta: [], description: "", title: "" }
SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  pathname: PropTypes.string,
  image: PropTypes.string,
}
export default SEO
